import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import IYCApp from "./IYC-App";

const isIYC = window.location.pathname.startsWith("/in-your-corner");
const Root = isIYC ? IYCApp : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
